import { supabase } from './supabase';
import { parseCampaigns, type Audience, type CampaignRow } from './whatsapp';

/**
 * Campagnes WhatsApp (brique G) — I/O Supabase via RPC sécurisées (super_admin only,
 * cf. sql/28_whatsapp.sql). Logique pure dans whatsapp.ts.
 */

export interface SaveCampaignInput {
  title: string;
  message: string;
  audience: Audience;
  tenantId: string | null;
  recipientCount: number;
  status?: 'draft' | 'ready' | 'sent';
}

export interface SaveCampaignResult {
  ok: boolean;
  id?: string;
  error?: string;
}

/** Enregistre une campagne dans l'historique. */
export async function saveCampaign(input: SaveCampaignInput): Promise<SaveCampaignResult> {
  const { data, error } = await supabase.rpc('save_whatsapp_campaign', {
    p_title: input.title,
    p_message: input.message,
    p_audience: input.audience,
    p_tenant_id: input.tenantId,
    p_recipient_count: input.recipientCount,
    p_status: input.status ?? 'ready',
  });
  if (error) {
    return { ok: false, error: `Enregistrement de la campagne impossible : ${error.message}` };
  }
  return { ok: true, id: data ? String(data) : undefined };
}

export interface LoadCampaignsResult {
  ok: boolean;
  campaigns: CampaignRow[];
  error?: string;
}

/** Charge l'historique des campagnes. */
export async function loadCampaigns(): Promise<LoadCampaignsResult> {
  const { data, error } = await supabase.rpc('list_whatsapp_campaigns');
  if (error) {
    return { ok: false, campaigns: [], error: error.message };
  }
  return { ok: true, campaigns: parseCampaigns(data) };
}
